import { PLANT_PLACEHOLDER_IMAGE } from '../../@commons/ui-components/icon-svg/icon-svg.component';

/**
 * Image par défaut des vignettes de culture. L'ancien visuel de la boutique de
 * test renvoyait 404 : un cadre cassé dans le calendrier, le potager et les
 * graines (B7).
 */
export const DEFAULT_CULTIVATION_IMAGE = PLANT_PLACEHOLDER_IMAGE;

/**
 * URL du DERNIER fichier de l'objet, sinon `fallback`.
 *
 * Toujours recalculée à partir de l'objet courant : une vignette réutilisée pour
 * un objet sans fichier ne garde jamais l'image de l'objet précédent.
 */
export function lastFileUrl(item: unknown, fallback: string): string {
  const files = (item as { files?: { cdnUrl: string }[] } | null | undefined)?.files;
  return files?.length ? files[files.length - 1].cdnUrl : fallback;
}
